import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { SectionFieldRow } from "./SectionFieldRow";
import { useDebouncedInput, parseNullableNumber } from "./useDebouncedInput";

interface DurationFieldProps {
  value: number | null;
  onChange: (value: number | null) => void;
}

export function DurationField(props: DurationFieldProps) {
  const { t } = useTranslation();
  const { localValue, handleChange } = useDebouncedInput({
    initialValue: props.value,
    onChange: props.onChange,
    transform: parseNullableNumber,
  });

  return (
    <SectionFieldRow
      label={t("editWorkout.durationMinutes")}
      renderField={(id) => {
        return (
          <div className="flex items-center gap-1">
            <Input
              id={id}
              type="number"
              min={1}
              value={localValue}
              onChange={handleChange}
              className="h-7 w-14 text-sm bg-white/80 border-slate-200 px-2"
              placeholder="0"
            />
            <span className="text-xs text-slate-400">min</span>
          </div>
        );
      }}
    />
  );
}
